import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocThingEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 id="org" className="heading-1">Thing</h3>
                    <div className="description org">
                        Thing entities may be assigned an additional subtype(s) by the extraction model.
                    </div>

                    <div className="example-content">
                        <div className="line" id="sub_chemical">THING/CHEMICAL - <span className="example-content-nonitalic">a thing related to chemical compounds (e.g ibuprofen, Agent Orange, fluorescein)</span></div>
                        <div className="line" id="sub_event">THING/EVENT - <span className="example-content-nonitalic">an event (e.g. Hurricane Katrina, Iraq War, 2025 NFL Draft)</span></div>
                        <div className="line" id="sub_facility">THING/FACILITY - <span className="example-content-nonitalic">a thing related to structural facilities (e.g Skylark Hotel, Grand Canal Shoppes, Venetian Resort)</span></div>
                        <div className="line" id="sub_financial">THING/FINANCIAL - <span className="example-content-nonitalic">a thing related to finance (e.g. S&P 500 Index, NASDAQ 100, Bitcoin)</span></div>
                        <div className="line" id="sub_legal">THING/LEGAL - <span className="example-content-nonitalic">a thing related to the legal field (e.g. Rules of Practice and Procedure, Chapter 11, Central America Free Trade Agreement)</span></div>
                        <div className="line" id="sub_medical">THING/MEDICAL - <span className="example-content-nonitalic">a thing related to the medical field (e.g. Covid-19, Spanish Flu)</span></div>                     
                        <div className="line" id="sub_product">THING/PRODUCT - <span className="example-content-nonitalic">a product, (e.g. iPhone 16, Tesla Model S)</span></div>
                        <div className="line" id="sub_program">THING/PROGRAM - <span className="example-content-nonitalic">a broadcast program (e.g. Anderson Cooper 360, Squak Box, Shark Tank)</span></div>
                        <div className="line" id="sub_technology">THING/TECHNOLOGY - <span className="example-content-nonitalic">a thing related to the technology field (e.g. LIDAR, Deep Learning, 5G)</span></div>
                    </div>
                    <br/>

                    <div className="description">
                        The entity type of "THING" is assigned to things 
                        that are not assigned to one of the above thing subtypes.<br/>
                        <br/>
                        Thing white lists and black lists may be used to extend 
                        Finch for Text or to tune it for certain data domains. Please 
                        contact us for details.
                    </div>
                    
                    <div className="description">
                        An extracted thing entity does not currently have attributes.
                    </div>
                </div>

                <div>
                    <h4 id="do" className="heading-3">Disambiguated Thing</h4>

                    <div className="description">
                        A thing that has been disambiguated will have a disambiguated object that contains the
                        top disambiguated result. We include the disambiguation confidence score, the id of the
                        entity, and the preferred label of the entity. The entity id can be used in a
                        GET {urlHandler.API_ENDPOINT_V2_ENTITIES}/{'{'}entity_id{'}'} call to retrieve more
                        information about the thing, as described above in the API section of
                        this document.
                    </div>
                </div>

                <h4 className="heading-2">Examples</h4>
                <div className="example-content">The front of both new phones look similar to Apple's iPhone X, with the screen engulfing nearly the entire phone.</div>
                <HttpRunner example="thing1" 
                    query="enrich"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_THING) : null}/>
            </div>
        );
    }
}

export default DocThingEntity;